<template>
  <div style="overflow: hidden;">
    <Header></Header>
    <div class="banner-bgimg">
      <div class="wave-area">
        <div class="wave1"></div>
        <div class="wave2"></div>
      </div>
      <div class="container">
        <div class="container-cord">
          <div class="container-cord-img"><img src="../../static/img/1.png" alt=""></div>
          <div class="container-cord-text">
            <h1>服务用能企业物联网化</h1>
            <p>泛物网络提供物联网平台、物联网边缘计算、企业能耗监控管理平台、工业园区综合能源管理平台、城市管网智能检测诊断平台、让物联网成为必须品</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务 -->
    <div class="translate">
      <div class="translate-top">
        <h3>专业的服务</h3>
        <p>泛物网络是集软硬于一体的低成本的综合性工业物联网支持平台，终端末端一体化，助力工业企业实现物联网化</p>
      </div>
      <div class="translate-cord">
        <div class="translate-cord-img" :class="isdh>=1?'animation-r':''" style="float: right;">
          <img src="../../static/img/2.png" alt="">
        </div>
        <div class="translate-cord-text" :class="isdh>=1?'animation-l':''" style="float: left;">
          <h4>泛物网络售电支持平台</h4>
          <p>泛物网络售电支持平台是基于泛物网络基础应用平台开发的一款低成本的售电支持平台，辅助售电行业企业转型至能源科技节能科技类服务企业，降低转型成本，助力售电行业有序发展。</p>
          <ul>
            <li><i class="el-icon-check"></i>支持大规模分布式部署，海量连接，性能强悍</li>
            <li><i class="el-icon-check"></i>物联设备一站式接入集成，可视化配置</li>
            <li><i class="el-icon-check"></i>提供全方位售电业务信息化支撑，满足客户服务、售电测算、增值服务</li>
            <li><i class="el-icon-check"></i>“量体裁衣”制定优质节能方案，提高用电效率、优化资源配置</li>
            <li><i class="el-icon-check"></i>客户可以针对不同时段，来监控电量的成交金额</li>
          </ul>
        </div>
      </div>
      <div class="translate-cord">
        <div class="translate-cord-img " :class="isdh>=2?'animation-l':''" style="float: left;">
          <img src="../../static/img/3.png" alt="">
        </div>
        <div class="translate-cord-text " :class="isdh>=2?'animation-r':''" style="float: right;">
          <h4>泛物网络数据监控平台</h4>
          <p>泛物网络数据监控平台是基于泛物网络强大的超算及时序数数据解析能力进行设备数据监控、分析、故障预警、寿命分析、节能核算等，助力中小型工业企业进行产业升级。</p>
          <ul>
            <li><i class="el-icon-check"></i>在线监控、电价设置、数据分析、数据统计</li>
            <li><i class="el-icon-check"></i>以技术手段实时监控提供实时与历史的在线数据监控功能</li>
            <li><i class="el-icon-check"></i>依托大数据分析开展精准运维，实现有周期</li>
            <li><i class="el-icon-check"></i>并用扇形图直观的展现出尖峰、高峰、平段、谷段四个时刻电量及所产生费用的占比</li>
            <li><i class="el-icon-check"></i>实现有周期的展示每个时段的用电情况。</li>
          </ul>
        </div>
      </div>
      <div class="translate-cord">
        <div class="translate-cord-img " :class="isdh>=3?'animation-r':''" style="float: right;">
          <img src="../../static/img/4.png" alt="">
        </div>
        <div class="translate-cord-text " :class="isdh>=3?'animation-l':''" style="float: left;">
          <h4>泛物网络物联网中心平台</h4>
          <p>泛物网络物联网中心平台是泛物网络应用的基础平台，全新的物联网结构，是云盒产品的灵魂，5000P的时序存储和超级计算为核心打造新型的数据中心结构，让超级计算为基础技术服务，开创用能节能的新时代</p>
          <ul>
            <li><i class="el-icon-check"></i>支持大规模分布式部署，海量连接，性能强悍</li>
            <li><i class="el-icon-check"></i>物联设备一站式接入集成，可视化配置</li>
            <li><i class="el-icon-check"></i>支持百亿级数据的存储、查询和聚合分析</li>
            <li><i class="el-icon-check"></i>内置高速规则引擎，快速应用集成</li>
            <li><i class="el-icon-check"></i>跨平台可伸缩，适配各种类型和规模的基础设施</li>
          </ul>
        </div>
      </div>
      <div class="translate-cord">
        <div class="translate-cord-img " :class="isdh>=4?'animation-l':''" style="float: left;">
          <img src="../../static/img/6.png" alt="">
        </div>
        <div class="translate-cord-text " :class="isdh>=4?'animation-r':''" style="float: right;">
          <h4>泛物网络城市供水管网检测平台</h4>
          <p>泛物网络城市供水管网检测平台 是利用世界首款管道内无人潜航器对供水管道进行三维地图造影，利用声波定位，分段式影像数据传输，造影对比绘制管道内的损坏模型，为有效降低漏失率提供解决方案。</p>
          <ul>
            <li><i class="el-icon-check"></i>利用声波定位，分段式影像数据传输</li>
            <li><i class="el-icon-check"></i>特有的分布式信号传输方式完美解决了检测设备与监测系统的衔接</li>
            <li><i class="el-icon-check"></i>可以简单有效的绘制管网漏失损坏三维模型。</li>
            <li><i class="el-icon-check"></i>造影对比绘制管道内的损坏模型，为有效降低漏失率</li>
          </ul>
        </div>
      </div>

    </div>
    <!-- 我们的优势 -->
    <div class="advantage">
      <div class="advantage-cord">
        <div class="advantage-title">
          <h3>我们的优势</h3>
        </div>
        <div class="advantage-box">
          <el-row>
            <el-col :span="8" :class="istop==1?'animation-t':''" v-for='(item,index) in arryushi' :key='index'>
              <div class="">
                <div class="dh-bg bg-theme-90">
                  <img :src="item.imgurl">
                </div>
                <h5 >{{item.title}}</h5>
                <p>{{item.text}}</p>
              </div>
            </el-col>
          </el-row>

        </div>
      </div>
    </div>
    <!-- ========== 合作伙伴 ========== -->

    <div class="partner">
      <div class="title">合作伙伴</div>
      <div class="text">有朋友,有故事</div>
      <div class="partner-content">
       <ul >
          <li v-for="(item,index) in partnerImg" :key='index'>
            <img :src="item" alt="">
            <!-- <a href="#javascript;;" :style="'background-image: url('++');'"></a> -->
          </li>
        </ul>
      </div>
    </div>
    <!-- 邂逅 -->
    <div class="index-contact">
        <div class="wp">
          <h6>现在，非常期待与您的又一次邂逅</h6>
          <p>泛物的努力让每一次邂逅都能超越期待</p>
          <div class="wpbtn"@click="goto('aboutus','productId')"> <a href="#javascript;;"><em></em> <span>立即联系</span></a></div>
        </div>
        <div class="cover"></div>
    </div>
<!-- 联系我们 -->
 <div @click="goto('aboutus','productId')" class="Conbtn" style="position: fixed;width: 200px;height: 50px;bottom: 40px;right: 40px;color: #fff;
    background-color: #393bc2;line-height: 50px;border-radius: 5px;text-align: center;font-size: 20px;z-index: 10;"> <i class="el-icon-chat-line-round" style="margin-right: 10px;;"></i>联系我们</div>
    <Footer></Footer>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        partnerImg:[
          '../../static/img/hzimg1.png',
          '../../static/img/hzimg2.png',
          '../../static/img/hzimg3.png',
          '../../static/img/hzimg4.png',
          '../../static/img/hzimg5.png',
          '../../static/img/hzimg6.png',
          '../../static/img/hzimg7.png',
          '../../static/img/hzimg13.png',
          '../../static/img/hzimg9.png',
          '../../static/img/hzimg10.png',
          '../../static/img/hzimg11.png',
          '../../static/img/hzimg12.png'
        ],
        // service: [{
        //     title: "设备接入及应用开发平台",
        //     text: "泛物云提供设备快速接入及敏捷应用开发能力，通过安全稳定的云端服务保障，帮助客户轻松实现基于自身业务场景的物联网应用。",
        //     url: "http://www.ablecloud.com/img/matrix%20logo.svg",
        //     list:['支持大规模分布式部署，海量连接，性能强悍','物联设备一站式接入集成，可视化配置','支持百亿级数据的存储、查询和聚合分析','内置高速规则引擎，快速应用集成','跨平台可伸缩，适配各种类型和规模的基础设施'],
        //   },
        //   {
        //     title: "设备管理及业务运营平台",
        //     text: "提供可视化的设备管理及业务运营的能力，满足客户设备维保、数据统计分析等全面的运营功能，帮助实现高效的运营管理。",
        //     url: "http://www.ablecloud.com/img/genius-logo.svg?v=660264e621410adcbb2b3474ca73bb11"
        //   },
        //   {
        //     title: "大数据分析及应用平台",
        //     text: "提供大数据交互式分析能力，赋能全员零编码实现自定义数据探索分析，实时结果输出助力客户进行精准决策。",
        //     url: "http://www.ablecloud.com/img/inspire-logo.svg?v=19241444fc2f48b1d74c971da4adf2f4"
        //   }, {
        //     title: "自然能源及能源结构",
        //     text: "利用建筑周围的太阳能、风能、地热、水资源等实现能源生产或节约",
        //     url: "http://www.ablecloud.com/img/matrix%20logo.svg"
        //   }
        // ],
        isdh: 0,
        istop:0,
        ArrShow:[
          {title:"开放平台",
          text:"广泛兼容多类型物联网数据采集设备、网关、应用，为物联网行业生态伙伴提供多种开放能力服务和基础应用解决方案",
          imgurl:"../../static/img/s1.png"},
          {title:"积累沉淀",
          text:"承载以水电气暖基础节能领域为核心的30余个行业基础应用，具备丰富的项目应用对接经验",
          imgurl:"../../static/img/s2.png"},
          {title:"研发实力",
          text:"研发团队高精尖人才众多，具备多项业界顶尖资质",
          imgurl:"../../static/img/s3.png"}
        ],
        arryushi:[],
        ArrTrust:[
          {
            name:"工厂能源托管节能",
            tiele:"",
            text:"工业厂区应以尽可能少的资源投入和环境代价，实现尽可能多的收益产出，实现企业可持续发展方向。",
            bgimg:"",
          },{
            name:"酒店能源托管节能",
            tiele:"",
            text:"酒店应用完善的能源托管节能系统，有效对应水、电、煤等能源价格波动，降本增效增强企业竞争力。",
            bgimg:"",
          },{
            name:"医院能源托管节能",
            tiele:"",
            text:"行业研究医疗建筑用能特点表明，空调制冷与采暖系统占全年能耗40%-50%，应重点击破节能减排。",
            bgimg:"",
          },{
            name:"写字楼能源托管节能",
            tiele:"",
            text:"写字楼为业主提供水电、网络、中央空调及消防监控等服务，除代扣代缴之外，耗能支出成本占比超过40%，能源托管就是丰盈现金流。",
            bgimg:"",
          },
        ]
      }
    },
    watch: {
        istop: function(newVal, oldVal) {
            if(newVal==1){
             var timer=setInterval(()=>{
                this.arryushi.push(this.ArrShow[this.arryushi.length])
                console.log(this.arryushi);
                if(this.arryushi.length==3){
                  clearInterval(timer);
                }
              },200);
            }
        }
    },
    mounted() {
      window.addEventListener('scroll', this.getScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.getScroll);
    },
    methods: {
      //监听滚动
      getScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        console.log(this.scrollTop);
        var top = this.scrollTop
        top>=140&&top<800?this.isdh = 1:top>=800&&top<1380?this.isdh = 2:top >= 1380&&top<1970?this.isdh = 3:top >= 1970&&top<2150?this.isdh = 4:
        console.log(this.isdh);
        if(this.scrollTop >= 3000) {
          if(this.istop == 0){
           this.istop = 1
          }
        }
      },
      goto(page,selectId){
        var path = page;
        var selectId = selectId;
        localStorage.setItem("toId",selectId);
        this.$router.push({name: path, query: {info:true}});
      }
    }

  };
</script>



// WEBPACK FOOTER //
// src/views/HomePage.vue